import React from 'react';
import Aux from '../../hoc/Aux';
import { useTranslation } from 'react-i18next';

const productSystemTableRowKabel = (props) => {

  const { t } = useTranslation();

  const colFwk = props.colFwk;
  const colLayer = props.colLayer;
  const colAnzahl = props.colAnzahl;
  const fromToValue = props.fromToValue;
  const isSelected = props.isSelected;
  const globalGap = props.globalGap;

  const products_col = (item) => {
    if (item.products !== null && item.products !== "" && item.products !== []) {
      return item.products.map((product, index) => { 
        if (product.producttype === "woven") {
          return product.title + " (" + product.woven_amount + "x " + product.woven_layer + ")"
        } else if (product.producttype === "thing") {
          return product.title + " (" + product.thing_amount + ")"
        } else {
          return product.title
        } 
      }).join(", ")
    } else {
      return ""
    } 
  }

  if (props.item.gap === globalGap || globalGap === undefined) {
    return (
      <Aux>
        <th onClick={props.onToggle} className={props.color + " colLeft"} >{t(props.item.penetrations)}{colAnzahl(props.item.amount_min, props.item.amount_max)}</th>

        { (isSelected)?
          <Aux>
            <td onClick={props.onSubstract} className={props.color + " colLeft add-remove-handles"}  style={{width: "40px"}}><i className="material-icons icon-orange grow">remove_circle</i></td>
            <td className={props.color}  style={{width: "40px", fontSize: "20px"}}>{props.amount}x</td>
            <td onClick={props.onAdd}className={props.color + " colLeft add-remove-handles"}  style={{width: "40px"}}><i className="material-icons icon-orange grow">add_circle</i></td></Aux> : null
        }
        { (!isSelected)?
          <Aux>
            <td onClick={props.onToggle} className={props.color}  colSpan={3} style={{width: "120px"}}></td></Aux> : null
        }

        <td onClick={props.onToggle} className={props.color} >{fromToValue(props.item.min_diameter_buendel,props.item.max_diameter_buendel)}</td>
        <td onClick={props.onToggle} className={props.color} >{fromToValue(props.item.min_diameter_eir,props.item.max_diameter_eir)}</td>
        <td onClick={props.onToggle} className={props.color} >{fromToValue(props.item.min_diameter_einzelleitung, props.item.max_diameter_einzelleitung)}</td>
        <td onClick={props.onToggle} className={props.color + " colLeft"} >{  products_col(props.item) }</td>
        <td onClick={props.onToggle} className={props.color} style={{width: "90px"}}>{colFwk(props.item.classification, props.item.tube_configuration)}</td>
        <td onClick={props.onToggle} className={props.color + " colLeft"} style={{width: "100px"}}>{props.item.certification_reference}</td>
      </Aux>
      )
    } else {
      return (
        <Aux>
          <th onClick={props.onToggle} className={props.color + " colLeft disabledLine"} >{t(props.item.penetrations)}{colAnzahl(props.item.amount_min, props.item.amount_max)}</th>
          <td onClick={props.onToggle} className={props.color + " disabledLine"}  colSpan={3} style={{width: "120px"}}></td>
          <td onClick={props.onToggle} className={props.color + " disabledLine"} >{fromToValue(props.item.min_diameter_buendel,props.item.max_diameter_buendel)}</td>
          <td onClick={props.onToggle} className={props.color + " disabledLine"} >{fromToValue(props.item.min_diameter_eir,props.item.max_diameter_eir)}</td>
          <td onClick={props.onToggle} className={props.color + " disabledLine"} >{fromToValue(props.item.min_diameter_einzelleitung, props.item.max_diameter_einzelleitung)}</td>
          <td onClick={props.onToggle} className={props.color + " colLeft disabledLine"} >{  products_col(props.item) }</td>
          <td onClick={props.onToggle} className={props.color + " disabledLine"} style={{width: "90px"}}>{colFwk(props.item.classification, props.item.tube_configuration)}</td>
          <td onClick={props.onToggle} className={props.color + " colLeft disabledLine"} style={{width: "100px"}}>{props.item.certification_reference}</td>
        </Aux>
        )
    }
};



export default productSystemTableRowKabel;



// WEBPACK FOOTER //
// ./src/components/Shared/ProductSystemTableRowKabel.js